/* 検索項目 セレクトボックス */
import React, { memo } from 'react';
import { KeyValue } from '../types/KeyValue';

interface Props {
  name: string;
  label: string;
  value: string;
  valid_message?: Array<string>;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  options: Array<KeyValue>;
}

const SearchSelect: React.FC<Props> = ({
  name,
  label,
  value,
  valid_message,
  handleChange,
  placeholder,
  options,
}) => {
  return (
    <div className="col-md-4">
      <span className="search-criteria-head">{label}</span>
      <select
        name={name}
        className="search-form-input-large"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      >
        {options?.map((option, index) => {
          return (
            <option key={index} value={option.key}>
              {option.value}
            </option>
          );
        })}
      </select>
      {valid_message && (
        <span className="is-invalid">
          <strong>{valid_message[0]}</strong>
        </span>
      )}
    </div>
  );
};

export default memo(SearchSelect);
